document.addEventListener('click', e => {
  if (e.target.classList.contains('spoiler__button')) {
    let spoilerElem = e.target.closest('.spoiler');
    spoilerElem.classList.toggle('open');
    spoilerElem.classList.toggle('closed');
  }
});